import $ from 'jquery'
import 'core-js/stable'
import 'regenerator-runtime/runtime'

import './component.scss'

import { debounce } from 'Packs/src/subsidies/utils/debounce'

// ルートクラス定義
const ROOT_TARGET_CLASS_NAME = 'js-accordionContentWithHeading-root-target'
const ROOT_TARGET_SELECTOR = `.${ROOT_TARGET_CLASS_NAME}`

const accordionContentWithHeading = () => {
  // タブレットの最小サイズ
  const MIN_TABLET_WIDTH_NUMBER = 577

  // セレクタ定義
  const OPEN_TRIGGER_CLASS_NAME = 'js-accordionContentWithHeading-open-trigger'
  const OPEN_TRIGGER_SELECTOR = `.${OPEN_TRIGGER_CLASS_NAME}`

  const DISPLAY_TARGET_CLASS_NAME = 'js-accordionContentWithHeading-display-target'
  const DISPLAY_TARGET_SELECTOR = `.${DISPLAY_TARGET_CLASS_NAME}`

  // 開いた状態のクラス定義
  const OPEN_CLASS_NAME = 'is-open'

  // 処理
  const $rootElement = $(ROOT_TARGET_SELECTOR)

  $rootElement.each((index, root) => {
    const $openTrigger = $(root).find(OPEN_TRIGGER_SELECTOR)
    const $displayTarget = $(root).find(DISPLAY_TARGET_SELECTOR)

    $openTrigger.on('click', (event) => {
      event.preventDefault() // イベントの無効化

      if ($(root).hasClass(OPEN_CLASS_NAME)) {
        $(root).removeClass(OPEN_CLASS_NAME)
        $displayTarget.slideUp(300)
      } else {
        $(root).addClass(OPEN_CLASS_NAME)
        $displayTarget.slideDown(300)
      }
    })
  })

  // PCではアコーディオンにならないのでコンテンツを表示させる
  $(window).on('resize', debounce(() => {
    if (window.innerWidth >= MIN_TABLET_WIDTH_NUMBER) {
      $rootElement.each((index, root) => {
        const $displayTarget = $(root).find(DISPLAY_TARGET_SELECTOR)

        $displayTarget.show()
      })
    } else {
      $rootElement.each((index, root) => {
        const $displayTarget = $(root).find(DISPLAY_TARGET_SELECTOR)

        if ($(root).hasClass(OPEN_CLASS_NAME)) {
          $displayTarget.show()
        } else {
          $displayTarget.hide()
        }
      })
    }
  }))
}

$(() => {
  // アコーディオン処理
  accordionContentWithHeading()
})
